import { render, staticRenderFns } from "./storefront-header-image-widget.vue?vue&type=template&id=62c94a49&"
import script from "./storefront-header-image-widget.vue?vue&type=script&lang=js&"
export * from "./storefront-header-image-widget.vue?vue&type=script&lang=js&"
import style0 from "./storefront-header-image-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports